import React from 'react';
import PropTypes from 'prop-types';
import Document from "../models/Document";
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

const DocumentRow = ({document, onDelete, type, emptyMessage, onUpdate, inputProps, isDisabled, hideDetails,...props}) => {

    if (!document?.path) {

        if (emptyMessage) {
            return (
                <div className="empty-talent-project-documents-container">
                    {emptyMessage}
                </div>
            )
        }
    }

    if (!(document instanceof Document)) {
        document = Document.make({...document})
    }

    return (
        <div className="talent-document-row" {...props}>
            <div className="flex flex-row items-center justify-start gap-1.5">
                <i className={`far fa-${document.getFileIcon()}`}/>
                {(hideDetails && document.id) ? (
                    <a href={document.path} target="_blank"
                       className="text-sm line-clamp-1 flex-grow text-decoration-none">
                        {document.name}
                    </a>
                ) : (
                    <p className="text-sm line-clamp-1 flex-grow">
                        {document.name}
                    </p>
                )}
            </div>

            {!hideDetails && (
                <div className="whitespace-nowrap">
                    Uploaded {TB.moment(document.uploaded_at).format('ll')}
                </div>
            )}
            {!hideDetails && (
                <div className={TB.mapClass("justify-end ", {
                    "flex-row flex-nowrap flex items-center": onDelete
                })}>
                    {document.id && (
                        <a href={document.path} target="_blank"
                           className="btn btn-outline-dark btn-outline-white">
                            Download
                            {type && (
                                <span>&nbsp;{type}</span>
                            )}
                        </a>
                    )}

                    {onUpdate && (
                        <label
                            className="btn btn-dark ml-2 mb-0">
                            <input type="file" id={TB.slugify(document.name)} name={document.name} onChange={e => {

                                let files = e.target.files;
                                if (files && files.length > 0) {
                                    const file = files[0];
                                    const lastDot = file.name.lastIndexOf('.');

                                    const fileName = file.name.substring(0, lastDot);
                                    const ext = file.name.substring(lastDot + 1);

                                    // console.log('onSelectFile', {fileName, ext, path: file.path});

                                    onUpdate(file)
                                }
                            }} style={{display: 'none'}}/>
                            Edit
                        </label>
                    )}
                    {onDelete && (
                        <button
                            disabled={isDisabled}
                            onClick={onDelete} className="btn btn-outline-dark ml-2">
                            Delete
                        </button>
                    )}

                </div>
            )}
        </div>
    );
};

DocumentRow.propTypes = {
    document: PropTypes.object,
    onDelete: PropTypes.any,
    onUpdate: PropTypes.any,
    type: PropTypes.any,
    disabled: PropTypes.any,
    emptyMessage: PropTypes.any
};

export default DocumentRow;